import { useState } from 'react';
import { SidebarItem } from '@backstage/core-components';
import AutoFixHighIcon from '@material-ui/icons/Assistant';
import { AiDataMaintenanceModal } from '../AiDataMaintenanceModal';

export const AiDataMaintenanceSidebar = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <SidebarItem
        icon={AutoFixHighIcon}
        text="AI Agent"
        onClick={handleOpen}
      />
      <AiDataMaintenanceModal open={open} onClose={handleClose} />
    </>
  );
};
